import React from "react";
import { Link } from "react-router-dom";
import { Phone, Mail } from "lucide-react";

const FLAGS = ["🇭🇹", "🇯🇲", "🇩🇴", "🇹🇹", "🇧🇧"];

const LINKS = [
    { to: "/privacy", label: "Privacy Policy" },
    { to: "/terms", label: "Terms of Service" },
    { to: "/refund", label: "Refund Policy" },
    { to: "/blogs", label: "Blogs" },
    { to: "/affiliates", label: "Become an Affiliate" },
    { to: "/account", label: "My Account" },
];

export default function Footer() {
    return (
        <footer
            data-testid="site-footer"
            className="bg-navy text-white pt-20 pb-10 px-6"
        >
            <div className="max-w-5xl mx-auto flex flex-col items-center gap-5 text-center">
                <img
                    src="https://customer-assets.emergentagent.com/job_haiti-flavors-boston/artifacts/d6079zc1_file_00000000e4f071f8926f38a90a1f87a6.png"
                    alt="Caribbean Meal Prep"
                    className="w-36 sm:w-40 h-auto"
                />
                <p className="text-gold tracking-[0.4em] text-xs font-bold">
                    BOSTON · MASSACHUSETTS
                </p>
                <div
                    className="flex gap-3 text-3xl mt-1"
                    aria-label="caribbean nations"
                >
                    {FLAGS.map((f, i) => (
                        <span key={i}>{f}</span>
                    ))}
                </div>
                <p className="text-white/70 max-w-md text-[15px] leading-relaxed">
                    Eat well on the go. Healthy, hand-made Caribbean meals
                    delivered across Greater Boston.
                </p>

                {/* Get in touch */}
                <div
                    data-testid="footer-contact"
                    className="mt-6 w-full max-w-md rounded-2xl bg-white/5 border border-white/10 backdrop-blur p-5"
                >
                    <p className="text-gold tracking-[0.35em] text-[11px] font-bold uppercase">
                        Get in touch
                    </p>
                    <div className="mt-3 flex flex-col sm:flex-row sm:justify-center gap-3 sm:gap-6">
                        <a
                            data-testid="footer-phone"
                            href="tel:+17812818027"
                            className="inline-flex items-center justify-center gap-2 text-white hover:text-gold transition-colors text-sm sm:text-[15px] font-medium"
                        >
                            <Phone size={15} className="text-gold" />
                            (781) 281-8027
                        </a>
                        <a
                            data-testid="footer-email"
                            href="mailto:caribbeanmealp@gmail.com"
                            className="inline-flex items-center justify-center gap-2 text-white hover:text-gold transition-colors text-sm sm:text-[15px] font-medium"
                        >
                            <Mail size={15} className="text-gold" />
                            caribbeanmealp@gmail.com
                        </a>
                    </div>
                </div>

                <nav
                    data-testid="footer-links"
                    aria-label="Footer"
                    className="mt-6 flex flex-wrap items-center justify-center gap-x-7 gap-y-3"
                >
                    {LINKS.map((link) => (
                        <Link
                            key={link.to}
                            to={link.to}
                            data-testid={`footer-link-${link.to.replace("/", "")}`}
                            className="text-sm text-white/85 hover:text-gold transition-colors font-medium"
                        >
                            {link.label}
                        </Link>
                    ))}
                </nav>

                <div className="mt-6 pt-6 border-t border-white/10 w-full text-xs text-white/50">
                    © 2026 Caribbean Meal Prep · Proudly Haitian-inspired 🇭🇹
                </div>
            </div>
        </footer>
    );
}
